import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconNotebook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.25 4c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v1.25H6a.75.75 0 0 1 0 1.5H4.75v2.5H6a.75.75 0 0 1 0 1.5H4.75v2.5H6a.75.75 0 0 1 0 1.5H4.75v2.5H6a.75.75 0 0 1 0 1.5H4.75V20c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25zM14 15.25a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1 0-1.5zm2-4a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1 0-1.5zm-1.5-4a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5zM20.75 20A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20v-1.25H2a.75.75 0 0 1 0-1.5h1.25v-2.5H2a.75.75 0 0 1 0-1.5h1.25v-2.5H2a.75.75 0 0 1 0-1.5h1.25v-2.5H2a.75.75 0 0 1 0-1.5h1.25V4A2.75 2.75 0 0 1 6 1.25h12A2.75 2.75 0 0 1 20.75 4z",
		fill: "currentColor"
	})
});
export { SvgIconNotebook as ReactComponent };
